import AbstractController from '../src/services/ControllersRepository/AbstractController';
import OrdersList from '../views/orders/OrdersList';
import OrderCreateForm from '../views/orders/OrderCreateForm';
import OrderUpdateForm from '../views/orders/OrderUpdateForm';

export default class Orders extends AbstractController {
    protected controllerName = 'Orders';

    protected getDefaultListComponent() {
        return OrdersList;
    }

    protected getDefaultCreateFormComponent() {
        return OrderCreateForm;
    }

    protected getDefaultUpdateFormComponent() {
        return OrderUpdateForm;
    }
}
